export const selectWorkshopSearchResults = (state) => {
        return state.workshopSearch.list
};

export const selectWorkshopSearchLoading = (state) => state.workshopSearch.loading;
export const selectWorkshopSearchError = (state) => state.workshopSearch.error;
export const selectWorkshopSearchFilters = (state) => state.workshopSearch.filters;